import type LocomotiveScroll from 'locomotive-scroll';

export const initFooterLinkFocus = (scroll: LocomotiveScroll | null) => {
    const footerLinks = document.querySelectorAll('footer a')
  
    footerLinks.forEach(link => {
      if (!(link instanceof HTMLElement) || link.dataset.footerFocusReady === 'true') {
        return;
      }

      link.dataset.footerFocusReady = 'true';
      link.addEventListener('focus', () => {
        if (scroll) {
          scroll.scrollTo(document.body.scrollHeight, {
            duration: 0,
          });
          return;
        }

        link.scrollIntoView({
          block: 'nearest',
          inline: 'nearest',
        });
      } )
    })
}
